import { SignUpPassInitGetRequestModel } from "@/features/user/services/sign-up-pass-model";
import { SignUpPassApi } from "@/features/user/services/sign-up-pass-api";

// サインアップパスワード設定ページ表示前処理
export class SignUpPassService {
  private signUpPassApi = new SignUpPassApi();

  /**
   * サインアップパスワード設定ページ表示前処理API実行
   */
  public async signUpPassInit(param: SignUpPassInitGetRequestModel) {
    return await this.signUpPassApi.signUpPassInit(param);
  }
}
